import { render } from "./ChatUserInfo.vue?vue&type=template&id=17402dda&scoped=true"
import script from "./ChatUserInfo.vue?vue&type=script&lang=js"
export * from "./ChatUserInfo.vue?vue&type=script&lang=js"

import "./ChatUserInfo.vue?vue&type=style&index=0&id=17402dda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17402dda"],['__file',"webpack-assets/vue/templates/chat/parts/ChatUserInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17402dda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17402dda', __exports__)) {
    api.reload('17402dda', __exports__)
  }
  
  module.hot.accept("./ChatUserInfo.vue?vue&type=template&id=17402dda&scoped=true", () => {
    api.rerender('17402dda', render)
  })

}


export default __exports__